export default "__VITE_ASSET__Db3Q6lMx__"